import React from 'react';
import DatePicker from 'react-datepicker';
import {connect} from 'react-redux';
import {postWeek} from '../../../actions/app/mpt/weeks';
import './Week/Week.css';

class CreateWeek extends React.Component {
  state = {
    startDate: null,
    endDate: null,
    textWindow: '',
    colorBackground: '#f7f7f7',
    colorText: '#4a4a4a',
    modifying: false,
  };

  createWeek() {
    const {
      startDate,
      endDate,
      textWindow,
      colorBackground,
      colorText,
    } = this.state;
    const {dispatch} = this.props;
    if (startDate && endDate && textWindow && colorBackground && colorText) {
      dispatch(
        postWeek({
          start: startDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
          end: endDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
          display: {
            textWindow,
            colorBackgroundWindow: colorBackground,
            colorTextWindow: colorText,
          },
        }),
      );
      this.setState({
        startDate: null,
        endDate: null,
        textWindow: '',
        colorBackground: '#f7f7f7',
        colorText: '#4a4a4a',
        modifying: false,
      });
    }
  }

  render() {
    const {
      startDate,
      endDate,
      textWindow,
      colorBackground,
      colorText,
      modifying,
    } = this.state;
    return (
      <div>
        <h1>Create week</h1>
        <div className="row">
          <div className="col-md-3 text-center">
            <p>START</p>
            <DatePicker
              selected={startDate}
              onChange={date =>
                this.setState({startDate: date, modifying: true})
              }
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="d/M/yyyy hh:mm aa"
              timeCaption="time"
            />
          </div>
          <div className="col-md-3 text-center">
            <p>END</p>
            <DatePicker
              selected={endDate}
              onChange={date => this.setState({endDate: date, modifying: true})}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="d/M/yyyy hh:mm aa"
              timeCaption="time"
            />
          </div>
        </div>
        <div className="row">
          <div className="text-center col-md-3">
            <p className="text-center">Text</p>
            <textarea
              value={textWindow}
              onChange={text =>
                this.setState({textWindow: text.target.value, modifying: true})
              }
              alt=""
            />
          </div>
          <div className="text-center col-md-3">
            <p className="text-center">Color text</p>
            <div className="colorTextContainer">
              <select
                onChange={color =>
                  this.setState({
                    colorText: color.target.value,
                    modifying: true,
                  })
                }
                className="form-control"
                value={colorText}>
                <option>#4a4a4a</option>
                <option>#71C94C</option>
                <option>#E43D32</option>
                <option>#CECECE</option>
                <option>#E93F33</option>
                <option>#72BA4C</option>
                <option>#874DC4</option>
                <option>#76CC4C</option>
                <option>#FFFFFF</option>
                <option>#000000</option>
              </select>
              <div
                style={{
                  width: 32,
                  height: 32,
                  backgroundColor: colorText,
                  marginLeft: 20,
                }}
              />
            </div>
          </div>
          <div className="text-center col-md-3">
            <p className="text-center">Color background</p>
            <div className="colorTextContainer">
              <select
                onChange={color =>
                  this.setState({
                    colorBackground: color.target.value,
                    modifying: true,
                  })
                }
                className="form-control"
                value={colorBackground}>
                <option>#f7f7f7</option>
                <option>#71C94C</option>
                <option>#E43D32</option>
                <option>#CECECE</option>
                <option>#E93F33</option>
                <option>#72BA4C</option>
                <option>#874DC4</option>
                <option>#76CC4C</option>
                <option>#FFFFFF</option>
                <option>#000000</option>
              </select>
              <div
                style={{
                  width: 32,
                  height: 32,
                  backgroundColor: colorBackground,
                  marginLeft: 20,
                }}
              />
            </div>
          </div>
          <div
            className="col-md-3 text-center"
            style={{
              height: 100,
              width: '10%',
              backgroundColor: colorBackground,
              color: colorText,
            }}>
            {textWindow}
          </div>
          <div className="col-md-1">
            <button
              className={modifying ? 'btn-warning' : 'btn-success'}
              onClick={() => this.createWeek()}>
              Create week
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    weeks: state.app.mpt.weeks.list,
  }),
  dispatch => ({dispatch}),
)(CreateWeek);



// WEBPACK FOOTER //
// ./src/pages/MPT/Creation/createWeek.js